import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * SoulPracticeCard — a smaller editorial card used on the Inner
 * Exploration and Regulation & Presence pages. Imagery + copper icon +
 * title + one-line description + EXPLORE →.
 */
export default function SoulPracticeCard({
  title,
  tagline,
  image,
  to,
  disabled = false,
  disabledLabel = "Arriving soon",
  Icon,
  testid,
}) {
  const inner = (
    <>
      <div
        className="relative aspect-[16/10] bg-center bg-cover"
        style={{ backgroundImage: `url("${image}")` }}
      >
        <div
          aria-hidden
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(30,23,18,0.08) 0%, rgba(30,23,18,0.28) 100%)",
          }}
        />
        {Icon && (
          <div className="absolute top-4 left-4 w-9 h-9 rounded-full bg-[hsl(var(--paper))]/85 backdrop-blur-sm flex items-center justify-center">
            <Icon size={16} className="text-[hsl(var(--copper))]" />
          </div>
        )}
      </div>
      <div className="p-6 md:p-7">
        <h4 className="font-display text-2xl tracking-tight text-[hsl(var(--fg))]">
          {title}
        </h4>
        <p className="mt-2 text-[14px] leading-relaxed text-[hsl(var(--fg))]/75 max-w-md">
          {tagline}
        </p>
        <div className="mt-6 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-[hsl(var(--copper))]">
          <span>{disabled ? disabledLabel : "Explore"}</span>
          {!disabled && (
            <ArrowRight
              size={12}
              className="transition-transform group-hover:translate-x-1"
            />
          )}
        </div>
      </div>
    </>
  );

  const shared =
    "group block relative overflow-hidden rounded-[20px] border transition-all duration-300";
  const style = {
    borderColor: "hsl(var(--line))",
    background: "hsl(var(--paper))",
    boxShadow: "0 10px 28px -22px rgba(30,23,18,0.30)",
  };

  if (disabled) {
    return (
      <div
        data-testid={testid}
        aria-disabled="true"
        className={`${shared} opacity-70 cursor-default`}
        style={style}
      >
        {inner}
      </div>
    );
  }
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`${shared} hover:-translate-y-[2px]`}
      style={style}
    >
      {inner}
    </Link>
  );
}
